"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrevious = usePrevious;
exports.default = void 0;

var _react = require("react");

/**
 * usePrevious - This hook is used for cases where we need to determine the
 * previous value of a prop, state, or other variable that may change across
 * component updates.
 */
function usePrevious(value) {
  const ref = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    ref.current = value;
  });
  return ref.current;
}

var _default = usePrevious;
exports.default = _default;
//# sourceMappingURL=usePrevious.js.map